import { useState, useEffect } from 'react';

const useLocation = () => {
  const [locationEnabled, setLocationEnabled] = useState(false);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        () => {
          setLocationEnabled(true);
        },
        () => {
          setLocationEnabled(false);
        }
      );
    } else {
      setLocationEnabled(false);
    }
  }, []);

  return locationEnabled;
};

export default useLocation;
